import styled from 'styled-components'

export const StickyCard = styled.div`
  position: sticky;
  top: 24px;
`
